/** Geofabrik gis_osm_roads_free / OSM highway=* fclass catalog for risk-map filters. */

export const ROAD_NETWORK_FCLASS_GROUPS = [
  {
    id: 'primary',
    label: 'Main roads',
    values: [
      { value: 'motorway', label: 'motorway — highway' },
      { value: 'motorway_link', label: 'motorway_link — highway ramp' },
      { value: 'trunk', label: 'trunk — trunk road' },
      { value: 'trunk_link', label: 'trunk_link — trunk ramp' },
      { value: 'primary', label: 'primary — primary road' },
      { value: 'primary_link', label: 'primary_link' },
      { value: 'secondary', label: 'secondary — secondary road' },
      { value: 'secondary_link', label: 'secondary_link' },
      { value: 'tertiary', label: 'tertiary — tertiary road' },
      { value: 'tertiary_link', label: 'tertiary_link' },
    ],
  },
  {
    id: 'urban',
    label: 'Minor / urban',
    values: [
      { value: 'residential', label: 'residential' },
      { value: 'unclassified', label: 'unclassified' },
      { value: 'living_street', label: 'living_street' },
      { value: 'service', label: 'service' },
      { value: 'pedestrian', label: 'pedestrian' },
    ],
  },
  {
    id: 'paths',
    label: 'Unpaved / paths',
    values: [
      { value: 'track', label: 'track' },
      { value: 'path', label: 'path' },
      { value: 'footway', label: 'footway' },
      { value: 'cycleway', label: 'cycleway' },
      { value: 'bridleway', label: 'bridleway' },
      { value: 'steps', label: 'steps' },
    ],
  },
  {
    id: 'other',
    label: 'Other',
    values: [
      { value: 'road', label: 'road — unspecified' },
      { value: 'construction', label: 'construction' },
    ],
  },
];

export const ROAD_NETWORK_FCLASS_VALUES = ROAD_NETWORK_FCLASS_GROUPS.flatMap((g) =>
  g.values.map((v) => v.value),
);

export const DEFAULT_EXCLUDED_FCLASSES = [
  'path',
  'footway',
  'pedestrian',
  'steps',
  'bridleway',
  'track',
];
